import {
    DerbyshireRecordType,
    DerbyshireRecordSubType
} from "./DerbyshireRecordTypes";
import { IStyleFactory } from "@esdm/map/dist/layers/vector/styles/IStyleFactory";
import Style, { StyleFunction } from "ol/style/Style";
import Fill from 'ol/style/Fill';
import Circle from 'ol/style/Circle';
import Stroke from 'ol/style/Stroke';
import RegularShape from 'ol/style/RegularShape';
import * as olHas from 'ol/has';


export class HbsmrStyleFactory implements IStyleFactory {

    public getStyle(recordType: string, recordSubType: string = null): Style[]
    {
        let style: Style[] = null;

        //try and resolve sub type first
        if (recordSubType !== null) {
            switch (recordSubType) {               

                case DerbyshireRecordSubType.ListedBuilding:
                    style = this.ListedBuilding();
                    break;

                case DerbyshireRecordSubType.ScheduledMonument:
                    style = this.ScheduledMonument();
                    break;
                              
                case DerbyshireRecordSubType.RegisteredParkAndGarden:
                    style = this.RegisteredParksAndGardens();
                    break;

                case DerbyshireRecordSubType.ConservationArea:
                    style = this.ConservationArea();
                    break;

                case DerbyshireRecordSubType.WorldHeritageSite:
                    style = this.WorldHeritageSite();
                    break;

                case DerbyshireRecordSubType.WorldHeritageSiteBufferZone:
                    style = this.WorldHeritageSiteBuffer();
                    break;

                case DerbyshireRecordSubType.AreaOfArchaeologicalInterest:
                    style = this.AreasOfArchaeologicalInterest();
                    break;
            }
        }

        if (style === null) {
            switch (recordType) {
                case DerbyshireRecordType.Monument:
                    style = this.Monument();
                    break;

                case DerbyshireRecordType.Designation:
                    style = this.Designation();
                    break;

                case DerbyshireRecordType.Paleochannels:
                    style = this.Paleochannels();
                    break;
            }
        }

        return style;
    }

    public getSelectedStyle(
        recordType: string = DerbyshireRecordType.Monument): Style[]
    {        
        return this.SelectedRecord();
    }

    private CommonStyle(fillColour: string): Style[] {
        var fill = new Fill({
            color: fillColour
        });
        var stroke = new Stroke({
            color: 'rgba(255,255,255,1)',
            width: 3
        });

        return [
            new Style({
                image: new Circle({
                    fill: fill,
                    stroke: stroke,
                    radius: 12
                }),
                fill: fill,
                stroke: stroke
            })
        ];
    }
    
    private Monument(): Style[] {      
        var fill = new Fill({            
            color: 'rgba(134, 140, 227, 0.5)'
        });
        var pointfill = new Fill({
            color: 'rgba(134, 140, 227, 0.9)'
        });
        var stroke = new Stroke({
            color: 'rgba(134, 140, 227, 1)',
            width: 2
        });

        return   [
            new Style({
                image: new Circle({
                    fill: pointfill,
                    stroke: stroke,
                    radius: 4
                }),
                fill: fill,
                stroke: stroke
            })
        ];

    }

    private Designation(): Style[] {
        return this.CommonStyle('rgba(132, 71, 15,0.8)');
    }


    private ScheduledMonument(): Style[] {


        // Generate a canvasPattern
        var canvas = document.createElement('canvas');
        var context = canvas.getContext('2d');
        var pixelRatio = olHas.DEVICE_PIXEL_RATIO;
        var pattern = (function () {
            // background
            canvas.width = 6 * pixelRatio;
            canvas.height = 6 * pixelRatio;
            context.fillStyle = 'rgba(212, 180, 227, 0.1)';
            context.fillRect(0, 0, canvas.width, canvas.height);
            // outer circle
            //context.fillStyle = 'rgba(102, 0, 102, 0.5)';
            //context.beginPath();
            //context.arc(4 * pixelRatio, 4 * pixelRatio, 3 * pixelRatio, 0, 2 * Math.PI);
            //context.fill();
            // inner circle
            context.fillStyle = 'rgba(212, 180, 227, 1.0)';
            context.beginPath();
            context.arc(4 * pixelRatio, 4 * pixelRatio, 1.5 * pixelRatio, 0, 2 * Math.PI);
            context.fill();
            return context.createPattern(canvas, 'repeat');
        }());


        var fill = new Fill({
            color: 'rgba(212, 180, 227, 0.6)'
        });
        fill.setColor(pattern);

        var stroke = new Stroke({
            color: 'rgba(212, 180, 227, 1.0)',
            width: 2
        });
        var pointfill = new Fill({
            color: 'rgba(212, 180, 227, 0.9)'
        });
        return [new Style({
            image: new RegularShape({
                fill: pointfill,
                stroke: stroke,
                points: 3,
                radius: 8,
                rotation: 0,
                angle: 0
            }),
            fill: fill,
            stroke: stroke
        })];
    }

    private ListedBuilding(): Style[] {
        var fill = new Fill({
            color: 'rgba(227, 137, 137, 0.6)'
        });
        var stroke = new Stroke({
            color: 'rgba(227, 137, 137, 1.0)',
            width: 2
        });
        var pointfill = new Fill({
            color: 'rgba(227, 137, 137, 0.9)'
        });
        return [new Style({
            image: new RegularShape({
                fill: pointfill,
                stroke: stroke,
                points: 3,
                radius: 8,
                rotation: 0,
                angle: 0
            }),
            fill: fill,
            stroke: stroke
        })];
    }


    private RegisteredParksAndGardens(): Style[] {
        //return this.CommonStyle('rgba(45, 123, 9,0.5)');   
        // Generate a canvasPattern
        var canvas = document.createElement('canvas');
        var context = canvas.getContext('2d');
        var pixelRatio = olHas.DEVICE_PIXEL_RATIO;
        var pattern = (function () {
            // background
            canvas.width = 6 * pixelRatio;
            canvas.height = 6 * pixelRatio;
            context.fillStyle = 'rgba(146, 183, 131, 0.1)';
            context.fillRect(0, 0, canvas.width, canvas.height);
            // outer circle
            //context.fillStyle = 'rgba(102, 0, 102, 0.5)';
            //context.beginPath();
            //context.arc(4 * pixelRatio, 4 * pixelRatio, 3 * pixelRatio, 0, 2 * Math.PI);
            //context.fill();
            // inner circle
            context.fillStyle = 'rgba(146, 183, 131, 1.0)';
            context.beginPath();
            context.arc(4 * pixelRatio, 4 * pixelRatio, 1.5 * pixelRatio, 0, 2 * Math.PI);
            context.fill();
            return context.createPattern(canvas, 'repeat');
        }());

        var fill = new Fill({
            color: 'rgba(146, 183, 131, 0.3)'
        });
        fill.setColor(pattern);

        var stroke = new Stroke({
            color: 'rgba(146, 183, 131, 1.0)',
            width: 2
        });
        var pointfill = new Fill({
            color: 'rgba(146, 183, 131, 0.9)'
        });
        return [new Style({
            image: new RegularShape({
                fill: pointfill,
                stroke: stroke,
                points: 3,
                radius: 8,
                rotation: 0,
                angle: 0
            }),
            fill: fill,
            stroke: stroke
        })];
    }


    private AreasOfArchaeologicalInterest(): Style[] {
        var fill = new Fill({
            color: 'rgba(255,255,102,0.6)'
        });
        var stroke = new Stroke({
            color: 'rgba(255,255,102,1)',
            width: 2
        });
        var pointfill = new Fill({
            color: 'rgba(255,255,102, 0.9)'
        });
        return [new Style({
            image: new RegularShape({
                fill: pointfill,
                stroke: stroke,
                points: 3,
                radius: 8,
                rotation: 0,
                angle: 0
            }),
            fill: fill,
            stroke: stroke
        })];
    }

    private ConservationArea(): Style[] {
        //return this.CommonStyle('rgba(239, 26, 28,0.5)');            
        // Generate a canvasPattern
        var canvas = document.createElement('canvas');
        var context = canvas.getContext('2d');
        // Gradient and pattern are in canvas pixel space, so we adjust for the
        // renderer's pixel ratio
        var pixelRatio = olHas.DEVICE_PIXEL_RATIO;
        var pattern = (function () {
            canvas.width = 32 * pixelRatio;
            canvas.height = 32 * pixelRatio;
            // background
            context.fillStyle = "rgba(238, 194, 85, 0.1)";
            context.fillRect(0, 0, canvas.width, canvas.height);

            var x0 = 36;
            var x1 = -4;
            var y0 = -4;
            var y1 = 36;
            var offset = 16;

            context.strokeStyle = "rgba(238, 194, 85, 1)";
            context.lineWidth = 2;
            context.beginPath();
            context.moveTo(x0, y0);
            context.lineTo(x1, y1);
            context.moveTo(x0 - offset, y0);
            context.lineTo(x1 - offset, y1);
            context.moveTo(x0 + offset, y0);
            context.lineTo(x1 + offset, y1);
            context.stroke();

            context.fillStyle = context.createPattern(canvas, 'repeat');
            context.fillRect(0, 0, canvas.width, canvas.height);

            return context.createPattern(canvas, 'repeat');
        }());
        var fill = new Fill({
            color: 'rgba(238, 194, 85, 0.4)'
        });
        fill.setColor(pattern);

        var stroke = new Stroke({
            color: 'rgba(238, 194, 85, 1)',
            width: 2
        });
        var pointfill = new Fill({
            color: 'rgba(238, 194, 85, 0.9)'
        });
        return [new Style({
            image: new RegularShape({
                fill: pointfill,
                stroke: stroke,
                points: 3,
                radius: 8,
                radius2: 4,
                angle: 0
            }),
            fill: fill,
            stroke: stroke
        })];
    }

    private WorldHeritageSiteBuffer(): Style[] {
        //return this.CommonStyle('rgba(27, 15, 220, 0.8)');   
        var fill = new Fill({
            color: 'rgba(191, 166, 144, 0.4)'
        });
        var stroke = new Stroke({
            color: 'rgba(191, 166, 144, 1.0)',
            width: 2
        });

        return [new Style({
            image: new RegularShape({
                fill: fill,
                stroke: stroke,
                points: 5,
                radius: 8,
                radius2: 4,
                angle: 0
            }),
            fill: fill,
            stroke: stroke
        })];
    }

    private WorldHeritageSite(): Style[] {

        // Generate a canvasPattern with two circles on white background
        var pattern = (function () {
            var canvas = document.createElement('canvas');
            var context = canvas.getContext('2d');
            // Gradient and pattern are in canvas pixel space, so we adjust for the
            // renderer's pixel ratio
            var pixelRatio = olHas.DEVICE_PIXEL_RATIO;
            canvas.width = 8 * pixelRatio;
            canvas.height = 8 * pixelRatio;
            context.fillStyle = "rgba(191, 166, 144, 0.1)";
            context.fillRect(0, 0, canvas.width, canvas.height);
            // outer circle
            //context.fillStyle = 'rgba(102, 0, 102, 0.5)';
            //context.beginPath();
            //context.arc(4 * pixelRatio, 4 * pixelRatio, 3 * pixelRatio, 0, 2 * Math.PI);
            //context.fill();
            // inner circle
            context.fillStyle = 'rgb(191, 166, 144)';
            context.beginPath();
            context.arc(4 * pixelRatio, 4 * pixelRatio, 1.5 * pixelRatio, 0, 2 * Math.PI);
            context.fill();
            return context.createPattern(canvas, 'repeat');
        }());


        var fill = new Fill({
            color: 'rgba(191, 166, 144, 1)'
        });
        fill.setColor(pattern);

        var stroke = new Stroke({
            color: 'rgba(191, 166, 144, 1.0)',
            width: 2
        });

        return [new Style({
            image: new RegularShape({
                fill: fill,
                stroke: stroke,
                points: 3,
                radius: 8,
                rotation: 0,
                angle: 0
            }),
            fill: fill,
            stroke: stroke
        })];
    }

    private Paleochannels(): Style[] {
        var fill = new Fill({
            color: 'rgba(128, 128, 128, 0.5)'
        });
        var pointfill = new Fill({
            color: 'rgba(128, 128, 128, 0.9)'
        });
        var stroke = new Stroke({
            color: 'rgba(128, 128, 128, 1)',
            width: 2
        });

        return [
            new Style({
                image: new Circle({
                    fill: pointfill,
                    stroke: stroke,
                    radius: 4
                }),
                fill: fill,
                stroke: stroke
            })
        ];

    }
        
    private SelectedRecord(): Style[] {
        var fill = new Fill({
            color: 'rgba(255, 255, 0, 0.5)'
        });

        return [
            new Style({
                image: new Circle({
                    fill: fill,
                    stroke: new Stroke({
                        color: 'rgba(255, 173, 10, 1)',
                        width: 3
                    }),
                    radius: 10
                }),
                fill: fill,
                stroke: new Stroke({
                    color: 'rgba(255, 173, 10, 1)',
                    width: 3
                })
            })
        ];
    }

}
